import React, { useEffect, useRef } from "react";
import {
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Tooltip
} from "@mui/material";
import MoreHorizSharpIcon from "@mui/icons-material/MoreHorizSharp";
import CustomAxios from "../utils/CustomAxios";
import { Menu as PrimeMenu } from "primereact/menu"; 
import { Toast } from "primereact/toast";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { useDispatch, useSelector } from "react-redux";
import { updateHomeBanners,updateModal,updateEdit,updateHomeBannerDetails,updateSearchHomeBanner } from "../Redux/home_banner";

export function HomeBannerTable() {
  const dispatch = useDispatch();
  const homeBanners = useSelector((state) => state.homeBanner.homeBanners);
  const searchValue = useSelector(state => state.homeBanner.searchhomeBanners);

  const toast = useRef(null);
  const menuRefs = useRef([]);
  
  // Get user role and assigned hubs
  const user_role = localStorage.getItem('role');
  const assignedHubs = JSON.parse(localStorage.getItem('hub') || '[]');
  
  // Function to check if a hub is assigned to the current user
  const isHubAssigned = (hubId) => {
    if (user_role === 'super_admin') {
      return true; // Super Admin has access to all hubs
    }
    return assignedHubs.includes(hubId);
  };
  
  // Function to check if banner is assigned to current user's hubs
  const isBannerAssigned = (banner) => {
    if (user_role === 'super_admin') {
      return true; // Super Admin has access to all banners
    }
    
    // Check if any of the banner's inventory hubs are assigned to the user
    if (banner.inventory && banner.inventory.length > 0) {
      return banner.inventory.some(inv => isHubAssigned(inv.id));
    }
    
    return false;
  };

  // useEffect(() => {
  //   const fetchBanners = async () => {
  //     try {
  //       const res = await CustomAxios.get("home_banner/");
  //       console.log("Fetched product banners:", res.data);
  //       dispatch(updateHomeBanners(homeBanners));
  //     } catch (err) {
  //       console.error("Error fetching product banners:", err);
  //     }
  //   };
  //   fetchBanners();
  // }, [dispatch]);

  // useEffect(()=>{
  //   console.log("homeBanners",homeBanners)
  // })
const handleOpen = (item) => {
  const modifiedItem = {
    ...item,
    inventory: item.inventory ? item.inventory.map(inv => inv.id) : [],
  };
  dispatch(updateHomeBannerDetails(modifiedItem));
  dispatch(updateEdit(true));
  dispatch(updateModal(true));
  console.log("Edit clicked for:", modifiedItem);
};


const confirmDelete = (item) => {
  confirmDialog({
    message: (
      <Box sx={{ display: "flex", gap: "10px", flexDirection: "column" }}>
        <Typography sx={{ fontSize: "16px", fontWeight: 500 }}>
        Do you want to delete this banner?
        </Typography>
      </Box>
    ),
    header: 'Delete Confirmation',
    defaultFocus: 'reject',
    acceptClassName: 'p-button-danger',
    accept: () => accept(item.id),
  });
};

const accept = async (id) => {
  try {
    await CustomAxios.delete(`home_banner/${id}/`);
    dispatch(updateHomeBanners(homeBanners?.filter(banner => banner.id !== id)));
    toast.current.show({ severity: "success", summary: "Deleted", detail: "Banner deleted successfully", life: 3000 });
  } catch (error) {
    console.error("Error deleting banner:", error);
    toast.current.show({ severity: "error", summary: "Error", detail: "Failed to delete banner", life: 3000 });
  }
};

const filteredBanners = homeBanners?.filter(banner => {
  // First apply hub-based filtering for super admin
  if (user_role === 'super_admin') {
    const selectedHubRaw = localStorage.getItem('selected_hub');
    let selectedHub;
    try {
      const parsedHub = JSON.parse(selectedHubRaw || '[]');
      selectedHub = Array.isArray(parsedHub) && parsedHub.length > 0 ? parsedHub[0] : parsedHub;
    } catch (error) {
      selectedHub = selectedHubRaw;
    }
    
    // If a specific hub is selected, filter banners by that hub
    if (selectedHub && selectedHub !== 'all' && selectedHub !== '[]') {
      const bannerHasSelectedHub = banner.inventory && banner.inventory.some(inv => 
        inv.id === selectedHub || inv.value === selectedHub
      );
      if (!bannerHasSelectedHub) return false;
    }
  } else {
    // For non-super admin users, use existing hub assignment logic
    if (!isBannerAssigned(banner)) return false;
  }
  
  // Then apply search filtering
  if (!searchValue) return true;
  const searchLower = searchValue.toLowerCase();
  return (
    (banner.name && banner.name.toLowerCase().includes(searchLower)) ||
    (banner.content && banner.content.toLowerCase().includes(searchLower))
  );
});

  return (
    <Box>
      <Toast ref={toast} />
       <ConfirmDialog />
      <Typography sx={{ fontSize: "16px", fontWeight: "700", lineHeight: "24px" }}>
        Product Banner List
      </Typography>
      <TableContainer sx={{ height: "100%" }}>
        <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }}>
          <TableHead style={{ backgroundColor: "background.upload" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">S No</TableCell>
              <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Banner Name</TableCell>
              <TableCell sx={{ fontWeight: "600", textAlign: "left",backgroundColor: "background.upload" }} align="left">Content</TableCell>
              <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Inventory</TableCell>
              <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Status</TableCell>
              <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredBanners?.length > 0 ? (
              filteredBanners.map((item, index) => {
                menuRefs.current[index] = menuRefs.current[index] || React.createRef();

                return (
                  <TableRow key={item.id}>
                    <TableCell
                      sx={{
                        textAlign: "left",
                        textTransform: "capitalize",
                        backgroundColor: "white",
                      }}
                    >
                      {index + 1}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "left",
                        textTransform: "capitalize",
                        backgroundColor: "white",
                      }}
                    >
                      {item.name || "-"}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "left",
                        textTransform: "capitalize",
                        backgroundColor: "white",
                      }}
                    >
                      {item.content || "-"}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "left",
                        textTransform: "capitalize",
                        backgroundColor: "white",
                      }}
                    >
                      {item.inventory && item.inventory.length > 0
                        ? item.inventory
                          .map(
                            (inv) => inv.place || inv.name || `Inventory ${inv.id}`
                          )
                          .join(", ")
                        : "No Inventory"}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "left",
                        textTransform: "capitalize",
                        backgroundColor: "white",
                      }}
                    >
                      {item.status ? "Active" : "Inactive"}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "left",
                        textTransform: "capitalize",
                        backgroundColor: "white",
                      }}
                    >
                      <PrimeMenu
                        model={(() => {
                          const bannerAssigned = isBannerAssigned(item);
                          
                          if (user_role === 'super_admin') {
                            // Super Admin: Can edit and delete all banners
                            return [
                              { label: "Edit", command: () => handleOpen(item) },
                              { label: "Delete", command: () => confirmDelete(item) },
                            ];
                          } else if (user_role === 'admin') {
                            if (bannerAssigned) {
                              // Admin: Can edit and delete assigned banners
                              return [
                                { label: "Edit", command: () => handleOpen(item) },
                                { label: "Delete", command: () => confirmDelete(item) },
                              ];
                            } else {
                              // Admin: View only for unassigned banners
                              return [
                                { label: "View Only", command: () => handleOpen(item), disabled: true },
                              ];
                            }
                          } else if (user_role === 'supervisor') {
                            if (bannerAssigned) {
                              // Supervisor: Can edit assigned banners (limited fields)
                              return [
                                { label: "Edit Limited Fields", command: () => handleOpen(item) },
                              ];
                            } else {
                              // Supervisor: View only for unassigned banners
                              return [
                                { label: "View Only", command: () => handleOpen(item), disabled: true },
                              ];
                            }
                          } else {
                            // Other roles: View only
                            return [
                              { label: "View Only", command: () => handleOpen(item), disabled: true },
                            ];
                          }
                        })()}
                        popup
                        ref={menuRefs.current[index]}
                        style={{ marginTop: "-10px" }}
                        className="custom-menu"
                      />
                      <Tooltip title="Actions" arrow>
                        <IconButton
                          sx={{ textTransform: "none" }}
                          onClick={(event) =>
                            menuRefs.current[index]?.current?.toggle(event)
                          }
                        >
                          <MoreHorizSharpIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={8} sx={{ textAlign: "center", height: "200px" }}>
                  No Product Banners Found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
